import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CCloseButton,
  CImage,
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
  CSidebarNav,
} from '@coreui/react-pro'

import { AppSidebarNav } from './AppSidebarNav'
import logo from 'src/assets/logo.png'
import { AuthContext } from 'src/contexts/authContext'
import SimpleBar from 'simplebar-react'

// sidebar nav config
import navigation from '../_nav'
import { TenderNavigation } from '../_tenderNavigation.js'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)

  const currentRoute = useLocation().pathname.toLowerCase()
  const tenderChapterNavigation = TenderNavigation()

  const { systemSettings, userInfo } = useContext(AuthContext)

  return (
    <CSidebar
      className='border-end'
      colorScheme='dark'
      position='fixed'
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarHeader className='border-bottom'>
        <CSidebarBrand href='/'>
        { systemSettings?.replaceLogoPerTenderOffice && userInfo?.departments?.length
          ? <div className='demo-platform-logo'>DEVIS PLATFORM</div>
          : <CImage src={logo} height={32} />
        }
        </CSidebarBrand>
        <CCloseButton
          className='d-md-none'
          dark
          onClick={() => dispatch({ type: 'set', sidebarShow: false })}
        />
      </CSidebarHeader>

      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={navigation} />
        </SimpleBar>
        {currentRoute.includes('tender-detail-view') && (
          <SimpleBar>
            <AppSidebarNav items={tenderChapterNavigation} />
          </SimpleBar>
        )}
      </CSidebarNav>
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
